// extracted by mini-css-extract-plugin
export default {"root":"ProTooltip__root--1xh5Z","title":"ProTooltip__title--11XKv","features":"ProTooltip__features---Mmd7","link":"ProTooltip__link--2ptFP","icon":"ProTooltip__icon--1CvDS"};